// Motivational content for Xunzhine.
// Messages are hard-coded and split into time-of-day buckets. Each bucket holds
// ~100 short (one to two line) lines. A bucket + a random message are chosen on
// every load and refreshed automatically while the app stays open.

export const MORNING_MESSAGES = [
  "Today is a blank page. Write a story worth reading.",
  "Win the morning and you win the day.",
  "Small steps before breakfast become giant leaps by dusk.",
  "Your future is built one early morning at a time.",
  "Wake up with purpose, not just an alarm.",
  "The first hour you own decides the day you'll have.",
  "Discipline now, freedom later. Start today.",
  "Greatness loves an early start.",
  "Don't wait for motivation. Move, and it will follow.",
  "A focused morning beats a frantic afternoon.",
  "You didn't wake up today to be average.",
  "One good habit before 9 AM changes everything.",
  "Coffee in hand, goals in sight. Let's go.",
  "Sunrise is proof: every day deserves a fresh try.",
  "Begin before you feel ready. Readiness comes from doing.",
  "Make today so good that yesterday gets jealous.",
  "Your dreams won't chase themselves. Start now.",
  "The early effort is the unfair advantage.",
  "Plant the seeds this morning; harvest them tonight.",
  "Be the reason your future self says thank you.",
  "Mornings are for momentum. Build some.",
  "Stretch your mind before you stretch your day.",
  "Do the hard thing first; the rest feels easy.",
  "Today's tiny progress is tomorrow's big win.",
  "You are one decision away from a better day.",
  "Rise. Grind. Repeat. Greatness is a routine.",
  "Energy is contagious. Start by inspiring yourself.",
  "The morning belongs to the brave. Claim it.",
  "Fresh start, clear mind, full focus.",
  "Every champion was once a beginner who showed up early.",
  "Turn your 'someday' into 'starting today'.",
  "Your goals heard the alarm too. Let's move.",
  "Don't count the days. Make the day count.",
  "A calm mind in the morning fuels a strong day.",
  "Show up for yourself before the world asks you to.",
  "The day is young and so is your potential.",
  "Set the tone now; the day will follow your lead.",
  "Big things start with a small first move this morning.",
  "Be unstoppable before lunch.",
  "Your morning mindset is your whole day's compass.",
  "Light beats the dark every single morning. So can you.",
  "Choose progress over comfort today.",
  "The world rewards those who begin.",
  "You have a fresh 24 hours. Spend them on yourself.",
  "Hard mornings forge unbreakable people.",
  "Start strong; the momentum will carry you.",
  "Today's effort is a gift to tomorrow's you.",
  "Make peace with mornings and they'll make you powerful.",
  "Wake the dream up before the doubt wakes up.",
  "Conquer the bed, then conquer the day.",
  "First you make your habits, then your habits make you.",
  "A productive morning is a quiet act of self-respect.",
  "Don't just rise. Rise with intention.",
  "The grind doesn't pause for snooze buttons.",
  "Be 1% better than you were yesterday.",
  "Your potential resets every sunrise. Use it.",
  "Mornings are silent invitations to greatness.",
  "Hustle quietly; let your results make the noise.",
  "Every expert started with one early, awkward attempt.",
  "Feed your focus, starve your distractions.",
  "Today is the perfect day to start that thing.",
  "The alarm is opportunity knocking. Answer it.",
  "Win this morning's small battle and gain the day.",
  "Your goals are closer than they were yesterday.",
  "Pour your energy in early; coast with confidence later.",
  "A strong start silences a thousand doubts.",
  "Move your body, clear your mind, own your day.",
  "Be the early bird that builds the empire.",
  "Stop scrolling. Start building.",
  "The morning is a mirror — show up as your best self.",
  "Greatness is a habit you practice at dawn.",
  "Lace up. Today doesn't run itself.",
  "Make momentum your morning ritual.",
  "What you do before noon shapes what you become.",
  "Today, trade excuses for effort.",
  "You are the author of this day. Begin chapter one.",
  "Tackle the giant task while you're still fearless.",
  "A clear plan turns a busy morning into a strong one.",
  "Each sunrise is a second chance in disguise.",
  "Begin with gratitude, continue with grit.",
  "The morning grind is where legends are quietly made.",
  "Don't dread the climb. Enjoy the view from each step.",
  "Be relentless before the world wakes up.",
  "Today's discipline is tomorrow's freedom.",
  "Your dream deserves an early, fearless start.",
  "Make today's first move your boldest.",
  "Quiet mornings, loud results.",
  "Start the day on offense, not defense.",
  "The best time to start was yesterday. The next best is now.",
  "Fuel up, focus in, follow through.",
  "Let your morning routine outwork your excuses.",
  "Rise for the goals that keep you up at night.",
  "A focused dawn defeats a scattered day.",
  "Be the kind of early that makes success inevitable.",
  "Your only competition is who you were yesterday.",
  "Make this morning a masterpiece in progress.",
  "Drink water, breathe deep, attack the day.",
  "The grind is grateful you woke up.",
  "Plant courage this morning; grow confidence all day.",
  "You've got a whole day to be amazing. Start now.",
  "Today is yours. Sign it with effort.",
];

export const AFTERNOON_MESSAGES = [
  "The day isn't over — your best work might be ahead.",
  "Refuel, refocus, and finish what you started.",
  "Halfway is not a place to stop. Keep going.",
  "A short break now powers a strong finish later.",
  "Momentum doesn't take a lunch break.",
  "Push through the slump; the win is on the other side.",
  "The afternoon rewards those who don't quit.",
  "You've come too far to coast now.",
  "Second wind, second chance. Use it.",
  "Stay sharp; the finish line is closer than you think.",
  "Don't let the afternoon dip win. You're stronger.",
  "Reset your focus and reclaim the day.",
  "Progress over perfection, all afternoon long.",
  "Keep stacking small wins until they're undeniable.",
  "The hardest hours build the proudest evenings.",
  "Tired is not done. Keep moving.",
  "Make the rest of today better than the start.",
  "Your goals are watching how you spend this hour.",
  "Stand up, stretch, and dive back in.",
  "Afternoons are for closing loops, not opening doubts.",
  "Finish the task that future-you will thank you for.",
  "One more focused push before the day fades.",
  "Energy dips, but discipline doesn't have to.",
  "Re-attack your to-do list like it owes you money.",
  "The day's not graded on how it started, but how it ends.",
  "Trade the afternoon scroll for an afternoon win.",
  "Keep the promises you made yourself this morning.",
  "Strong finishers are quietly made in the afternoon.",
  "Don't drift. Drive.",
  "Every hour you focus is an hour closer to your dream.",
  "Slow progress is still progress. Keep at it.",
  "Power through the plateau; the peak is near.",
  "Your effort now decides how good tonight feels.",
  "Stay in motion; momentum is your friend.",
  "The afternoon is a comeback waiting to happen.",
  "Don't ease off. Lean in.",
  "Make the second half your strongest half.",
  "Focus is a muscle. Flex it this afternoon.",
  "You're closer than the tiredness wants you to believe.",
  "Keep showing up; the results are stacking.",
  "A productive afternoon is a quiet kind of confidence.",
  "Beat the slump with one bold action.",
  "Don't let a slow hour become a wasted day.",
  "Recharge, then re-attack.",
  "Big goals are met one focused afternoon at a time.",
  "The grind continues. So do you.",
  "Turn the midday lull into a midday launch.",
  "You're building something. Add one more brick.",
  "Stay locked in; distraction is loud but weak.",
  "Make today's afternoon your competitor's nightmare.",
  "Finish the thing you keep postponing.",
  "Tired hands still build great things.",
  "Keep your eyes on the goal, not the clock.",
  "The afternoon belongs to the persistent.",
  "Don't stall at the halfway mark.",
  "Your dreams don't care that it's 3 PM.",
  "One more rep, one more task, one more step.",
  "Momentum loves people who refuse to stop.",
  "The grind is grateful you're still here.",
  "A focused afternoon turns a good day into a great one.",
  "Push past comfortable. That's where growth lives.",
  "Stay hungry through the lull.",
  "Keep your standards high even when energy is low.",
  "The work you avoid is the work that grows you.",
  "Refocus. Recommit. Resume.",
  "Halftime is over. Get back in the game.",
  "Let your afternoon prove your morning right.",
  "Tiny tasks add up to enormous wins.",
  "Don't waste the runway you built this morning.",
  "Discipline is choosing to continue when it's easy to stop.",
  "Show the afternoon what relentless looks like.",
  "Your goals are too important for an early checkout.",
  "Keep the streak alive, one hour at a time.",
  "Make the back half of the day your best work.",
  "Stay the course; the storm of doubt always passes.",
  "Effort now, ease later.",
  "The day's still yours to win.",
  "Don't negotiate with the urge to quit.",
  "Strong afternoons build unstoppable people.",
  "Re-energize and re-engage.",
  "Keep climbing; the summit doesn't move.",
  "You've got more in the tank than you think.",
  "Finish loud. Start with the next task.",
  "Persistence beats the afternoon every time.",
  "Make progress your default setting.",
  "The afternoon grind is where dreams get serious.",
  "Don't let comfort steal your momentum.",
  "Keep going — the best part of the day is still unwritten.",
  "Your focus this hour is an investment in your future.",
  "Stay relentless until the work is done.",
  "Turn 'I'm tired' into 'I'm almost there'.",
  "One more focused block. You've got this.",
  "The day rewards those who stay in the fight.",
  "Push the pace; the day is still moving.",
  "Trade hesitation for action this afternoon.",
  "Keep the engine running. Don't idle now.",
  "Your afternoon effort writes your evening pride.",
  "Stay sharp, stay steady, stay moving.",
  "Finish the day like you mean it.",
  "The afternoon is your second sunrise. Rise again.",
];

export const EVENING_MESSAGES = [
  "The day isn't done until you decide it is.",
  "End strong; how you finish is what you'll remember.",
  "One more meaningful push before you rest.",
  "Evenings are for closing the gap on your goals.",
  "Reflect on the wins, then add one more.",
  "Golden hour, golden effort.",
  "Finish the day proud of how you spent it.",
  "The quiet of evening is the loudest time to focus.",
  "Tie up today so tomorrow starts clean.",
  "Your evening effort is tomorrow's head start.",
  "Don't waste the calm — use it to create.",
  "A strong evening seals a strong day.",
  "Wrap up with intention, not just exhaustion.",
  "Make the last hours count as much as the first.",
  "Evening is proof you have one more chance today.",
  "Slow down, but don't stop dreaming.",
  "Let today end with a small act of progress.",
  "The sunset rewards those who showed up.",
  "Finish what you promised yourself this morning.",
  "End the day a step closer than you began.",
  "Evenings are for review, gratitude, and one last win.",
  "Don't let a tired body talk you out of a strong finish.",
  "Close the loops; sleep comes easier to the productive.",
  "The day's final hours can be its finest.",
  "Reflect, reset, and prepare to rise again.",
  "Your future is built in the hours others waste.",
  "Make peace with today by finishing it well.",
  "A calm evening of effort beats a restless night of regret.",
  "End the day as the person you want to become.",
  "The grind dims with the sun but never disappears.",
  "Evening focus is a superpower few use.",
  "One last task, then rest like you earned it.",
  "Let the evening be where you quietly win.",
  "Finish today's chapter before you close the book.",
  "Discipline doesn't clock out at sunset.",
  "Use the evening to plant tomorrow's success.",
  "Wind down the day, not your ambition.",
  "The day you finish strong is the day you grow.",
  "Tonight's effort is tomorrow's advantage.",
  "Reflect on progress, not just problems.",
  "End the day with a win, however small.",
  "Sunsets remind us: even endings can be beautiful.",
  "Your evening habits shape your morning self.",
  "Don't let the evening slip by unspent.",
  "A productive evening is the secret of calm people.",
  "Close today with purpose; open tomorrow with ease.",
  "The last mile of the day deserves your best stride.",
  "Trade evening distraction for evening direction.",
  "Make the most of the day's final light.",
  "End on a high note; momentum sleeps too.",
  "Evening is where the disciplined separate themselves.",
  "Finish the day so well that tomorrow can't wait.",
  "The dusk grind builds the dawn champion.",
  "Tidy the day so your mind can rest.",
  "Use this evening to be slightly better than yesterday.",
  "Your goals don't sleep until you've moved them forward.",
  "Make tonight's effort a gift to tomorrow.",
  "The day ends; your drive doesn't have to.",
  "Be proud of the hours you reclaimed today.",
  "Evenings reward reflection and resolve.",
  "Finish today's work; carry no debt into tomorrow.",
  "Let the evening calm sharpen your focus.",
  "One more step toward the dream before bed.",
  "End strong, sleep deep, rise ready.",
  "The evening grind is quiet but powerful.",
  "Spend your evening building, not just unwinding.",
  "A small evening victory is still a victory.",
  "Wrap the day in effort and gratitude.",
  "Don't drift into night — sail into it with purpose.",
  "The day's last hours can change everything.",
  "Finish the loop; free your mind.",
  "Evening focus turns ordinary days into great ones.",
  "Make your evening self proud of your morning promises.",
  "Use the calm hours to chase the bold dreams.",
  "End the day with one more reason to be proud.",
  "Quiet evenings build loud futures.",
  "Tonight, do the thing you've been avoiding.",
  "The sunset is a finish line. Cross it strong.",
  "Reflect, refine, and recommit before rest.",
  "Your evening discipline is your hidden edge.",
  "End the day in motion toward your goals.",
  "Let today's last effort be your proudest.",
  "Finish today like it mattered — because it did.",
  "Evenings are for sealing the day's success.",
  "Close the day with intention, open tomorrow with hope.",
  "The dream is closer than it was this morning. Push.",
  "End strong and rest easy.",
  "Make the evening yours before the night takes over.",
  "Tonight's small win is tomorrow's strong start.",
  "Finish the day with no regrets and one more step.",
  "The evening grind is where consistency is born.",
  "Trade the couch for one last meaningful move.",
  "End the day better than you began it.",
  "Let the sunset witness your follow-through.",
  "Your evening effort writes tomorrow's confidence.",
  "Wind down the noise, wind up the resolve.",
  "Finish today so completely that sleep feels earned.",
  "The day fades; let your effort glow.",
  "One last focused hour can redeem the whole day.",
  "End the day as a finisher, not a quitter.",
];

export const NIGHT_MESSAGES = [
  "While the world sleeps, the dreamers build.",
  "Late nights and big dreams go hand in hand.",
  "The quiet of night is where focus thrives.",
  "Burning the midnight oil? Make it count.",
  "Night owls write the stories morning people read.",
  "Your dedication doesn't have a bedtime.",
  "The stars are out, and so is your ambition.",
  "Silence the night with the sound of your hustle.",
  "Great things are often built after dark.",
  "Rest is earned by those who first do the work.",
  "If you're up late chasing dreams, you're doing it right.",
  "Midnight focus, morning results.",
  "The night belongs to the determined.",
  "When it's quiet outside, get loud on your goals.",
  "A little progress at night beats a lot of regret tomorrow.",
  "Dreams don't keep office hours.",
  "Let tonight's effort fuel tomorrow's pride.",
  "The grind glows brightest in the dark.",
  "Tired but driven beats comfortable but stuck.",
  "Night is just another chance to get closer.",
  "Protect your rest, but honor your goals first.",
  "The moon is up, and so is your potential.",
  "Quiet hours, clear focus, bold moves.",
  "Build in the dark; shine in the light.",
  "One more idea before you sleep can change everything.",
  "Late-night discipline writes early-morning victories.",
  "The world is asleep; your dreams are wide awake.",
  "Even at night, every step forward counts.",
  "Don't let the night pass without one small win.",
  "Rest your body, but never your ambition.",
  "Tonight's effort is a secret others won't match.",
  "The dark is the canvas; your work is the light.",
  "Stay focused; the night rewards the relentless.",
  "Wind down, but plant one seed for tomorrow.",
  "Late hours forge unstoppable people.",
  "Your goals whisper loudest in the quiet of night.",
  "Sleep is a reward; earn it with effort.",
  "Even the stars had to start somewhere.",
  "The night is calm — let your work be steady.",
  "Dreaming big is good; building at night is better.",
  "Make tonight a quiet investment in your future.",
  "When the noise fades, your purpose speaks.",
  "End the night knowing you moved forward.",
  "The midnight grind is lonely but legendary.",
  "Tonight's focus is tomorrow's freedom.",
  "Don't scroll the night away — build it away.",
  "The night sky is endless; so is your potential.",
  "Late and committed beats early and idle.",
  "Quiet nights build loud successes.",
  "Honor your dreams before you close your eyes.",
  "The hardest hours often hold the biggest breakthroughs.",
  "Let the night witness your work ethic.",
  "Rest well — but only after you've earned it.",
  "Even at this hour, your effort matters.",
  "The night is patient; use it wisely.",
  "Small steps at midnight still move mountains.",
  "Your future self is cheering for tonight's effort.",
  "Sleep on your wins, not your worries.",
  "When others rest, the driven get ahead.",
  "Tonight, choose progress over the snooze of comfort.",
  "Burn bright while the world goes dim.",
  "The night doesn't slow the determined.",
  "Finish the day with purpose, then rest in peace.",
  "Dreams built at night feel sweeter at dawn.",
  "Stay up for what matters, sleep easy after.",
  "The quiet hours are where focus is undefeated.",
  "Let your hustle outshine the moon.",
  "One last effort tonight saves a scramble tomorrow.",
  "Night owls turn silence into success.",
  "Even tired, you're still showing up. That's everything.",
  "The dark is just the backdrop for your light.",
  "Tonight's grind is tomorrow's glory.",
  "Rest is part of the plan, not the end of it.",
  "Make the night count, then close your eyes proud.",
  "Your ambition doesn't dim when the lights do.",
  "Quietly conquer the night.",
  "The late hours reward the loyal.",
  "Sleep is sweeter when the work is done.",
  "Keep going; the night still has something to give.",
  "Build tonight what you'll be proud of tomorrow.",
  "The night is yours. Spend it well.",
  "Dream it tonight, do it tomorrow, become it soon.",
  "Even the smallest progress tonight is a step forward.",
  "Let the moonlight fall on a person who tried.",
  "Wind down with gratitude for today's effort.",
  "The disciplined glow brightest in the dark.",
  "Tonight, be the reason tomorrow goes well.",
  "Quiet focus now, loud results later.",
  "The night is calm; let your resolve be calmer.",
  "Rest like you worked — fully and well.",
  "End the night one dream closer.",
  "The stars reward the ones who keep going.",
  "Late-night effort is the quiet flex of winners.",
  "Don't fear the late hour; own it.",
  "Tonight's persistence is tomorrow's proof.",
  "Sleep deep, dream big, wake ready.",
  "The night is long enough for one more step.",
  "Even now, you're building something great.",
  "Close the day with pride and the night with peace.",
];

// Returns the current time-of-day bucket key.
export function getTimeOfDay(date = new Date()) {
  const h = date.getHours();
  if (h >= 5 && h < 12) return "morning";
  if (h >= 12 && h < 17) return "afternoon";
  if (h >= 17 && h < 21) return "evening";
  return "night";
}

const MESSAGES_BY_TIME = {
  morning: MORNING_MESSAGES,
  afternoon: AFTERNOON_MESSAGES,
  evening: EVENING_MESSAGES,
  night: NIGHT_MESSAGES,
};

// Time-aware greeting templates. {name} is replaced with the user's name (or a
// friendly fallback). A random template is chosen so the greeting varies.
const GREETINGS_BY_TIME = {
  morning: [
    "Good Morning, {name}",
    "Rise and shine, {name}",
    "Hello, Early Bird {name}",
    "Top of the morning, {name}",
    "A fresh start, {name}",
    "Morning, {name} — let's go",
    "Good Morning, Champion {name}",
    "New day, new wins, {name}",
  ],
  afternoon: [
    "Good Afternoon, {name}",
    "Hello, Achiever {name}",
    "Keep the momentum, {name}",
    "Afternoon, {name} — stay sharp",
    "Halfway there, {name}",
    "Good Afternoon, Go-Getter {name}",
    "Powering through, {name}",
    "Hey {name}, finish strong",
  ],
  evening: [
    "Good Evening, {name}",
    "Hello, Sunset Striver {name}",
    "Evening, {name} — one more push",
    "Winding down, {name}? Finish well",
    "Good Evening, Hustler {name}",
    "Golden hour, {name}",
    "Hey {name}, end the day proud",
    "Evening grind, {name}",
  ],
  night: [
    "Good Night, {name}",
    "Hello, Night Owl {name}",
    "Burning the midnight oil, {name}?",
    "Late-night legend, {name}",
    "Good Night, Dreamer {name}",
    "Quiet hours, big focus, {name}",
    "Hey {name}, the night is yours",
    "Still going, {name}? Respect",
  ],
};

function pickRandom(arr) {
  if (!arr || arr.length === 0) return "";
  return arr[Math.floor(Math.random() * arr.length)];
}

// Builds a greeting string for the given time of day and name.
export function getGreeting(name, date = new Date()) {
  const tod = getTimeOfDay(date);
  const safeName = (name && name.trim()) || "Champion";
  const template = pickRandom(GREETINGS_BY_TIME[tod]) || "Hello, {name}";
  return template.replace("{name}", safeName);
}

// Returns a random motivational message for the given time of day.
export function getMotivationalMessage(date = new Date()) {
  const tod = getTimeOfDay(date);
  return pickRandom(MESSAGES_BY_TIME[tod]);
}
